

export const selectAccessory = (state, index) => {
  const selected = !state.accessoriesListInfo[index].selected
  state.accessoriesListInfo[index].selected = selected

  if(!selected){
    const found_index = state.accessories.findIndex((accessory) => accessory.product_id === state.accessoriesListInfo[index].id)
    if(state.accessories[found_index].line_item_id) state.accessoriesToDestroy.push(state.accessories[found_index].line_item_id)
    state.accessories = state.accessories.filter((accessory) => accessory.product_id !== state.accessoriesListInfo[index].id)
    return;
  }

  state.accessories.push({
    product_id: state.accessoriesListInfo[index].id,
    variant_id: state.accessoriesListInfo[index].selected_variant.id,
    quantity: state.accessoriesListInfo[index].quantity,
    price: state.accessoriesListInfo[index].selected_variant.price,
    line_item_id: null,
  })
}